import React, { useRef, useState } from "react"
import { shallowEqual, useSelector } from "react-redux";
import { FilterGroup } from "../../../../../../Common/components/FilterGroup";
import { Card, CardBody, CardHeader, CardHeaderToolbar } from "../../../../../../../../_metronic/_partials/controls";
import DynamicSimpleTable from "../../../../../../../util/DynamicSimpleReactTable";
import {
    errorMessage,
    formatAmount,
    formatDate,
    formatStatus,
    permissionAllow,
    permissionCssClass
} from "../../../../../../../util/Helpers";
import cogoToast from "cogo-toast";
import { Button } from "react-bootstrap";
import { Permissions, PermissionType } from "../../../../../../../util/Permissions";
import SVG from "react-inlinesvg";
import { toAbsoluteUrl } from "../../../../../../../../_metronic/_helpers";
import FreezeCardModal from "../../../../../../CardManagement/pages/modals/FreezeCardModal";
import UnfreezeCardModal from "../../../../../../CardManagement/pages/modals/UnfreezeCardModal";
import ViewCardModal from "../../../../../../CardManagement/pages/modals/ViewCardModal";

function Cards(
    {
        match: {
            params: {
                userId
            }
        }
    }
) {
    const adminUser = useSelector(({ auth }) => (auth.user), shallowEqual);
    const selectedUser = useSelector(({selectedUser}) => {
        const data = selectedUser?.data?.profile?.basic?.userId === userId ? selectedUser.data : null;
        return data;
    }, shallowEqual);
    const tableRef = useRef();

    const cardStatuses = ["verified", "pending", "processing", "active", "failed", "inactive", "completed", "cancelled", "executed", "complete"]

    const [cardModal, setCardModal] = useState({
        showViewCardModal: false,
        showFreezeCardModal: false,
        showUnfreezeCardModal: false,
        details: null
    });

    /* Modal show/hide Toggle */
    const toggleModal = modal => _ => {
        setCardModal({ ...cardModal, [modal]: !cardModal[modal] })
    }

    const viewCard = details => {
        setCardModal({ ...cardModal, showViewCardModal: true, details });
    }

    /* Freeze Card Modal*/
    const freezeCard = details => {
        setCardModal({
            ...cardModal,
            showFreezeCardModal: true,
            details
        })
    }

    /* Unfreeze Card Modal*/
    const unfreezeCard = details => {
        setCardModal({
            ...cardModal,
            showUnfreezeCardModal: true,
            details
        })
    }

    /* Action Buttons */
    const cardAction = (row) => {
        return (
            <span style={{ whiteSpace: "nowrap" }}>
                <Button
                    title="View Card"
                    className="btn btn-icon btn-light btn-hover-primary btn-sm bg-white"
                    onClick={_ => viewCard(row)}
                >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                        {
                            permissionAllow(adminUser, Permissions.CARDS, PermissionType.READ)
                            && <SVG
                                title="View Card"
                                src={toAbsoluteUrl(
                                    "/media/svg/icons/General/Eye-2.svg"
                                )}
                            />
                        }
                    </span>
                </Button>

                {row?.status !== "inactive"
                    ? <Button
                        title="Freeze Card"
                        className={`btn btn-icon btn-light btn-hover-primary btn-sm mx-3 ${permissionCssClass(adminUser, Permissions.CARDS, PermissionType.UPDATE)}`}
                        onClick={_ => freezeCard(row)}

                    >
                        <span className="svg-icon svg-icon-md svg-icon-primary">
                            <SVG
                                title="Freeze Card"
                                src={toAbsoluteUrl("/media/svg/icons/Weather/Snow.svg")}
                            />
                        </span>
                    </Button>
                    : <Button
                        title="Unfreeze Card"
                        className={`btn btn-icon btn-light btn-hover-primary btn-sm mx-3 ${permissionCssClass(adminUser, Permissions.CARDS, PermissionType.UPDATE)}`}
                        onClick={_ => unfreezeCard(row)}

                    >
                        <span className="svg-icon svg-icon-md svg-icon-primary">
                            <SVG
                                title="Unfreeze Card"
                                src={toAbsoluteUrl("/media/svg/icons/General/Fire.svg")}
                            />
                        </span>
                    </Button>
                }
            </span>
        );
    };

    return (
        <>
            <div className={"mb-4"}>
                <FilterGroup>
                    <FilterGroup.Content>
                        {
                            ({ filters }) => {
                                return <Card>
                                    <CardHeader title={`Cards`}>
                                        <CardHeaderToolbar>
                                            <div className={"ml-2"}>
                                                <FilterGroup.Filter name={"type"} label={"card type"}>
                                                    <FilterGroup.Option value={""}>All</FilterGroup.Option>
                                                    <FilterGroup.Option value={"VIRTUAL"}>virtual</FilterGroup.Option>
                                                    <FilterGroup.Option
                                                        value={"PHYSICAL"}>physical</FilterGroup.Option>
                                                </FilterGroup.Filter>
                                            </div>
                                            <div className={"ml-2"}>
                                                <FilterGroup.Filter name={"status"} label={"card status"}>
                                                    <FilterGroup.Option value={""}>All</FilterGroup.Option>
                                                    {
                                                        cardStatuses.map((status) => (
                                                            <FilterGroup.Option key={status} value={status}>
                                                                {status}
                                                            </FilterGroup.Option>
                                                        ))
                                                    }
                                                </FilterGroup.Filter>
                                            </div>
                                        </CardHeaderToolbar>
                                    </CardHeader>
                                    <CardBody>
                                        <DynamicSimpleTable
                                            key={userId}
                                            queryParams={
                                                `userGroup=${selectedUser?.profile?.basic?.userGroup || ""}`
                                                + `&userId=${userId || ""}`
                                                + `&type=${filters?.type || ""}`
                                                + `&status=${filters?.status || ""}`
                                            }
                                            searchBox={false}
                                            source={{ url: `/cards` }}
                                            columns={[
                                                { title: "CARD NAME", key: "cardName" },
                                                { title: "LAST 4", key: "last4" },
                                                { title: "CURRENCY", key: "currency" },
                                                { title: "TYPE", key: "cardType" },
                                                { title: "BALANCE", format: row => formatAmount(row.currency, row.balance) },
                                                { title: "EXPIRES ON", format: (row) => formatDate(row.expiry) },
                                                { title: "STATUS", format: row => formatStatus(row.status) },
                                                { title: "", format: cardAction }
                                            ]}
                                            ref={tableRef}
                                            onError={(err) =>
                                                cogoToast.error(errorMessage(err))
                                            }
                                            refreshIcon={true}
                                        />
                                    </CardBody>
                                </Card>
                            }
                        }
                    </FilterGroup.Content>
                </FilterGroup>
            </div>

            <ViewCardModal
                {...cardModal}
                onHide={toggleModal("showViewCardModal")}
            />

            <FreezeCardModal
                {...cardModal}
                tableRef={tableRef}
                onHide={toggleModal("showFreezeCardModal")}
            />

            <UnfreezeCardModal
                {...cardModal}
                tableRef={tableRef}
                onHide={toggleModal("showUnfreezeCardModal")}
            />
        </>
    )
}

export default Cards